import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";

export default function rejectRiderTrip(job_id) {
  console.log("hahacanceltrip", job_id);
  const Authorization = "bearer " + localStorage.getItem("token");
  const rider_id = localStorage.getItem("rider_id");
  fetch(`${API_URL}rest/V1/rider/tripReject`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      jobId: job_id,
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      // window.location.reload();
      return response.json();
    })
    .then(function (data) {
      // console.log("hahacanceltrip",data);
      // api.callShippingJobs(component,trip_id);
    });
}



// WEBPACK FOOTER //
// ./src/utility/api/rejectRiderTrip.js